// 名入れオプションアプリ(SA-025)の入力欄に対する文字種制御
// - 名入れ文字欄: 半角大文字アルファベットのみ許可（小文字・全角英字は自動で半角大文字に変換）
// - 背番号欄: 半角数字のみ許可（全角数字は自動で半角数字に変換）
// 対象の2つの入力欄は templates/product.json に固定IDで定義されたアプリブロックのため、IDを直接指定する
;(function () {
  var NAME_INPUT_ID =
    'AanlhS3VvSTVITDVMN__shopify_apps_blocks_product_name_option_form_d981ee3f_534c_473a_a071_ab0ea69d209b_L8R7KY-name-option'
  var NUMBER_INPUT_ID =
    'AaXpuWThvVXFSb2IvW__shopify_apps_blocks_product_name_option_form_d981ee3f_534c_473a_a071_ab0ea69d209b_8NjUeW-name-option'

  // 全角英字(Ａ-Ｚ/ａ-ｚ)を半角に変換してから大文字化し、A-Z以外を除去する
  function formatAlphaUpper(value) {
    var halfWidth = value.replace(/[\uFF21-\uFF3A\uFF41-\uFF5A]/g, function (char) {
      return String.fromCharCode(char.charCodeAt(0) - 0xfee0)
    })
    return halfWidth.toUpperCase().replace(/[^A-Z]/g, '')
  }

  // 全角数字(０-９)を半角に変換してから、0-9以外を除去する
  function formatDigits(value) {
    var halfWidth = value.replace(/[\uFF10-\uFF19]/g, function (char) {
      return String.fromCharCode(char.charCodeAt(0) - 0xfee0)
    })
    return halfWidth.replace(/[^0-9]/g, '')
  }

  // input要素に変換関数を適用し、maxLength属性を都度参照して切り詰める
  function bindFormatter(input, formatter) {
    if (!input) return

    input.addEventListener('input', function () {
      var originalValue = input.value
      var caretFromEnd = originalValue.length - input.selectionStart

      var formattedValue = formatter(originalValue)
      var maxLength = input.maxLength
      if (maxLength >= 0) {
        formattedValue = formattedValue.slice(0, maxLength)
      }

      if (formattedValue === originalValue) return

      input.value = formattedValue

      // カーソル位置を末尾からの相対位置で維持する
      var caretPosition = Math.max(0, formattedValue.length - caretFromEnd)
      input.setSelectionRange(caretPosition, caretPosition)
    })
  }

  function init() {
    bindFormatter(document.getElementById(NAME_INPUT_ID), formatAlphaUpper)
    bindFormatter(document.getElementById(NUMBER_INPUT_ID), formatDigits)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
